import { useUndo } from "../../Utils/undo";
import React, { useEffect, useContext, useState, useRef } from "react";
import MyContext from "../../context/MyContext";
import Fonts from "../middle.screen.parent.component/Fonts";
import Chrome from "react-color";
import Lottie from "lottie-web";
import { Tooltip } from "react-tippy";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import swal from "sweetalert";
import { Scale } from "@mui/icons-material";
import AnimationPanel from "./AnimationPanel";
const VideoSettings = () => {
  const {
    LeftPanelActive,
    setLeftPanelActive,
    IsTTSShow,
    setIsTTSShow,
    TTSData,
    setBackgrounds,
    setTTSData,
    EditorZoom,
    editableObject,
    LayersData,
    setLayersData,
    setChangeCount,
    ChangeCount,
    seteditableObject,
    clone,
    isTTS,
    setIsTTS,
    setRedoLayer,
    UndoLayer,
    setisTextInputOrAreaFocus,
    setAciveShapeColor,
    setUndoLayer,
  } = useContext(MyContext);
  const undo = useUndo();

  const [values, setvalues] = useState(editableObject.editableItem);
  const [rangeValue, setrangeValue] = useState(values.opacity * 100);
  const [Volume, setVolume] = useState(values.volume * 100);
  const [showMainPanel, setshowMainPanel] = useState(true);
  const [showAnimationPanel, setshowAnimationPanel] = useState(false);
  const [animationPanelType, setanimationPanelType] = useState("");
  useEffect(() => {
    setvalues(editableObject.editableItem);
    setisTextInputOrAreaFocus(false);
    setshowAnimationPanel(false);
    setshowMainPanel(true);
    if (editableObject.openAnimation) {
      setshowMainPanel(false);
      setshowAnimationPanel(true);
      setanimationPanelType(editableObject.animationPanelType);
    }
  }, [editableObject]);
  var currsize;

  const StackStore = () => {
    return new Promise((resolve) => {
      let stack = [...UndoLayer];
      let PrevArray = clone(LayersData);
      if (stack.length < 10) {
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      } else {
        stack.shift();
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      }
      resolve();
    });
  };

  //Lock function
  const lockFun = async () => {
    undo("lockFun"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].lock = !array[i].lock;
        array[i].Editable = false;
        break;
      }
    }
    setLayersData(array);
    //leftPanelHide
    seteditableObject({ showPanel: false, editableItem: [] });
  };

  //delete function
  const deleteFun = () => {
    undo("deleteFun"); // Ctrl+Z goes back to before this change
    // debugger;
    setIsTTS(false);
    var array = Array.from(LayersData);
    let changeArray = array.filter(function (value, index, arr) {
      if (value.key !== values.key) {
        return value;
      } else {
        if (value.type == "Props") {
          Lottie.destroy(value.AnimationId);
        } else if (value.type == "Character") {
          Lottie.destroy(value.AnimationId);
        }
      }
    });
    setLayersData(changeArray);
    seteditableObject({ showPanel: false, editableItem: [] });
  };

  //Duplicate Element Function
  const Duplicate = (params) => {
    undo("Duplicate"); // Ctrl+Z goes back to before this change
    var typelength = 1;
    var checkKey = 0;
    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }
    for (var i = 0; i < LayersData.length; i++) {
      if (LayersData[i].type === values.type) {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
      }
      if (LayersData[i].FurtherSetting === true) {
        LayersData[i].FurtherSetting = false;
      }
    }
    const array2 = JSON.parse(JSON.stringify(values));
    array2.key = checkKey + 1;
    array2.x = array2.x + 10;
    array2.y = array2.y + 10;
    array2.Name = `${values.type}-${typelength}`;
    array2.AnimationId = values.AnimationId + "-" + typelength;
    array2.layerIndex = topIndex;
    array2.toolbar = false;
    array2.FurtherSetting = false;
    array2.Editable = true;
    setLayersData(LayersData.concat(array2));
    seteditableObject({ showPanel: false, editableItem: [] });
  };

  //Opacity Function
  const changingOpacity = (value) => {
    undo("changingOpacity"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].opacity = value / 100;
        array[i].originalOpacity = value / 100;
        break;
      }
    }
    setLayersData(array);
    setrangeValue(Math.trunc(value));
  };

  //Volume Function
  const changeVolume = (value) => {
    undo("changeVolume"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].volume = value / 100;
        break;
      }
    }
    setLayersData(array);

    //forcefully changing value of video on document
    // var videoElement = document.getElementById("Video-" + values.AnimationId);
    // videoElement.volume = value / 100;
    //We have to do this on project load somehow.
    setVolume(value);
  };

  //Coverting RGB to Hex
  function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }
  //Coverting RGB to Hex
  function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
  }

  //Alignment to canvas function
  const alignCanvas = async (alignment) => {
    await StackStore();

    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (alignment === "left") {
          array[i].x = 0;
          array[i].orignalX = 0;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "right") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var xpostion =
            editor.clientWidth - (array[i].width * EditorZoom) / 100;
          array[i].x = (xpostion / EditorZoom) * 100;
          array[i].orignalX = xpostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "top") {
          array[i].y = 0;
          array[i].originalY = 0;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "bottom") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var ypostion =
            editor.clientHeight - (array[i].height * EditorZoom) / 100;
          array[i].y = (ypostion / EditorZoom) * 100;
          array[i].originalY = ypostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "centerV") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var ypostion =
            (editor.clientHeight - (array[i].height * EditorZoom) / 100) / 2;
          array[i].y = (ypostion / EditorZoom) * 100;
          array[i].originalY = ypostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "centerH") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var ypostion =
            (editor.clientWidth - (array[i].width * EditorZoom) / 100) / 2;
          array[i].x = (ypostion / EditorZoom) * 100;
          array[i].orignalX = ypostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        }
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
    //Repeating this to update the dragger
    const array2 = Array.from(LayersData);
    for (let i = 0; i < array2.length; i++) {
      if (array2[i].key === values.key) {
        array2[i].Editable = true;
        array2[i].showDiv = true;
        break;
      }
    }
    setLayersData(array2);
  };

  //Flip Horizontly
  const flipHorizontal = async (e) => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (array[i].flip === "scaleX(1)") {
          array[i].flip = "scaleX(-1)";
        } else {
          array[i].flip = "scaleX(1)";
        }
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };
  //Flip Horizontly
  const flipVertically = async (e) => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].rotateAngle = array[i].rotateAngle + 180;
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  const setImgAsBG = async () => {
    undo("setImgAsBG"); // Ctrl+Z goes back to before this change
    setBackgrounds({
      type: "image",
      color: null,
      Path: JSON.parse(JSON.stringify(values.ImageSrc)),
      gradient: { Gcolor: null, FirstColor: null, SecondColor: null },
    });
    const array = Array.from(LayersData);
    var changeArray = array.filter((item) => item.key !== values.key);
    setLayersData(changeArray);
    setChangeCount(ChangeCount + 1);
    //leftPanelHide
    seteditableObject({ showPanel: false, editableItem: [] });
  };
  //Some notes
  //   lh is for line height
  //   tr is space between characters
  //   fc is the color
  //   s is for scale
  //   layers ks.p.k  k: [542.542, 321.998, 0] are x y z positions
  // f is font family

  //

  return (
    <div>
      {showMainPanel && (
        <>
          <div className="d-flex topOptions mb-4">
            <div className="settingsTitle bolderFont">Edit Video</div>
            <div className="topRightOptions">
              <button
                onClick={() => {
                  setshowMainPanel(false);
                  setshowAnimationPanel(true);
                }}
                className="btn btn-small btn-Special mr-2"
              >
                Animate
              </button>
              <Tooltip
                title="Duplicate"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div className="topIcons grey" onClick={Duplicate}>
                  <span className="material-icons">content_copy</span>
                </div>
              </Tooltip>
              <Tooltip
                title="Delete"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div className="topIcons red" onClick={deleteFun}>
                  <span className="material-icons material-icons-outlined">
                    delete
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Lock"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div className="topIcons black" onClick={lockFun}>
                  <span className="material-icons material-icons-outlined">
                    lock
                  </span>
                </div>
              </Tooltip>
            </div>
          </div>

          <div className="LabelWithSlider Alignments">
            <div className="settingsTitle mb-2">Align to Canvas</div>
            <div className="opacitySlider">
              <Tooltip
                title="Align Canvas Left"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("left")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_horizontal_left
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Align Canvas Right"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("right")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_horizontal_right
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Align Canvas Top"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("top")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_vertical_top
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Align Canvas bottom"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("bottom")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_vertical_bottom
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Verticle Center"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("centerV")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_vertical_center
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Horizontal Center"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("centerH")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_horizontal_center
                  </span>
                </div>
              </Tooltip>
            </div>
          </div>
          <div className="LabelWithSlider Alignments">
            <div className="settingsTitle mb-2">Transform</div>
            <div className="opacitySlider">
              <Tooltip
                title="Flip X"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div onClick={flipHorizontal} className={"toggleIconSettings"}>
                  <span className="material-icons smallIcon selectIcon">
                    flip
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Flip Y"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div onClick={flipVertically} className={"toggleIconSettings"}>
                  <span
                    className="material-icons smallIcon selectIcon"
                    style={{ transform: "rotate(90deg)" }}
                  >
                    flip
                  </span>
                </div>
              </Tooltip>
            </div>
          </div>
          <div className="LabelWithSlider Transparency">
            <div className="settingsTitle">Transparency</div>
            <div className="opacitySlider">
              <div className="rangeSlider">
                <InputRange
                  maxValue={100}
                  minValue={0}
                  value={rangeValue}
                  onChange={(value) => changingOpacity(value)}
                />
              </div>
              <div className="opacityValue">{Math.round(rangeValue)}</div>
            </div>
          </div>
          <div className="LabelWithSlider Transparency">
            <div className="settingsTitle">Video Volume</div>
            <div className="opacitySlider">
              <div className="rangeSlider">
                <InputRange
                  maxValue={100}
                  minValue={0}
                  value={Volume}
                  onChange={(value) => changeVolume(value)}
                />
              </div>
              <div className="opacityValue">{Math.round(Volume)}</div>
            </div>
          </div>
          {/* <div className="mt-3 BackgroundBtn">
        <button className="btn btn-small btn-blue" onClick={setImgAsBG}>
          Set as Background
        </button>
      </div> */}
        </>
      )}

      {showAnimationPanel && (
        <AnimationPanel
          setshowMainPanel={setshowMainPanel}
          setshowAnimationPanel={setshowAnimationPanel}
          values={values}
          animationPanelType={animationPanelType}
        />
      )}
    </div>
  );
};
export default VideoSettings;
